import { getToast } from "../../../common/utils";
import {
  extractMetaDataOfDocumentForClauseCheck,
  getClauseCheckDataForDashboard,
  getClauseCheckDocumentsDataForDashboard,
  initiateClauseDataExtraction,
  uploadDraftingDocFromDrive,
  uploadFilesFromDriveForClauseCheck,
  uploadFilesFromDriveForRFxEvaluation,
  uploadRfxGeneratorDocFromDrive,
} from "../../../services/contracts.service";
import {
  convertDocToPdf,
  fileUploadFromDrive,
  uploadDraftingDocFromLocal,
  uploadFilesFromLocalForClauseCheck,
  uploadFromLocalToDrive,
  uploadMultipleFilesFromLocalForTalkToContract,
  uploadMultipleFilesToDrive,
  uploadRfxGeneratorDocFromLocal,
} from "../../../services/FileUpload.service";
import { resetTableState } from "../../../store/thunks/table.thunk";
import { TableTypes } from "../../ManageContract/constants";
import { BulkClauseTableData } from "../../ManageContract/model";
import { clauseCheckDocStatus, defaultSuggestions } from "../constants";
import {
  getContractsReview,
  getDocMetaData,
  getVmoBotResponse,
  uploadFilesForRFxEvaluation,
} from "../dashboard.service";
import {
  ClauseCheckDocumentRequestModel,
  ClauseCheckModel,
  ContractDocument,
  ContractReviewModel,
  FileForRfxEvaluation,
  MetaData,
  Suggestion,
} from "../model";
import {
  addDocExtentionIfMissing,
  getFileNameWithoutExtension,
} from "../utils";
import {
  getDraftingTemplatesList,
  getRfxGeneratorTemplatesList,
} from "../../../services/common.service";
import { IUploadedDocsForRFxEvaluation } from "../types";
import { determineIconUrl } from "../components/DashboardSelector/BotFileUpload/BotFileUpload";
import { uploadFileToGCS } from "../../../services/fetchFile.service";
import { Auth } from "../../../auth/auth";

export const CONTRACT_REVIEW_ACTIONS = {
  ADD_DOCUMENT: "ADD_DOCUMENT",
  REMOVE_DOCUMENT: "REMOVE_DOCUMENT",
  UPDATE_DETAILS_OF_UPLOADING_DOCUMENT: "UPDATE_DETAILS_OF_UPLOADING_DOCUMENT",
  UPDATE_FILE_UPLOAD_STATUS: "UPDATE_FILE_UPLOAD_STATUS",
  SET_CONTRACT_REVIEW_DATA: "SET_CONTRACT_REVIEW_DATA",
  UPDATE_PENDING_DOC_COUNT: "UPDATE_PENDING_DOC_COUNT",
  ADD_DOCUMENT_ID: "ADD_DOCUMENT_ID",
  DELETE_DOCUMENT_ID: "DELETE_DOCUMENT_ID",
  EMPTY_LIST: "EMPTY_LIST",
  STORE_CHAT: "STORE_CHAT",
  // SAVE_REVIEWING_STATE: "SAVE_REVIEWING_STATE",
};

export const CONTRACT_DRAFTING_ACTIONS = {
  UPDATE_CONTRACT_DRAFTING_DATA: "UPDATE_CONTRACT_DRAFTING_DATA",
  ADD_DRAFTING_DOCUMENT: "ADD_DRAFTING_DOCUMENT",
  SAVE_LOADER_STATE: "SAVE_LOADER_STATE",
  HANDLE_USE_EFFECT_COUNT: "HANDLE_USE_EFFECT_COUNT",
  STORE_FILE_ID: "STORE_FILE_ID",
};

export const RFX_GENERATOR_ACTIONS = {
  UPDATE_RFX_GENERATOR_DATA: "UPDATE_RFX_GENERATOR_DATA",
  ADD_RFX_GENERATOR_DOCUMENT: "ADD_RFX_GENERATOR_DOCUMENT",
};

export const CLAUSE_CHECK_ACTIONS = {
  ADD_DOCUMENT_FOR_CLAUSE_CHECK: "ADD_DOCUMENT_FOR_CLAUSE_CHECK",
  REMOVE_DOCUMENT_FROM_CLAUSE_CHECK: "REMOVE_DOCUMENT_FROM_CLAUSE_CHECK",
  UPDATE_DETAILS_OF_UPLOADING_DOCUMENT_FOR_CLAUSE_CHECK_AFTER_SUCCESSFUL_UPLOAD:
    "UPDATE_DETAILS_OF_UPLOADING_DOCUMENT_FOR_CLAUSE_CHECK_AFTER_SUCCESSFUL_UPLOAD",
  UPDATE_DATA_FOR_CLAUSE_CHECK_DOCUMENT:
    "UPDATE_DATA_FOR_CLAUSE_CHECK_DOCUMENT",
  SET_CLAUSE_CHECK_DATA: "SET_CLAUSE_CHECK_DATA",
  SET_FAILED_DOC_DATA: "SET_FAILED_DOC_DATA",
};

export const RFX_EVALUATION_ACTIONS = {
  UPDATE_RFX_EVALUATION_DATA: "UPDATE_RFX_EVALUATION_DATA",
};

export const VMO_BOT_ACTIONS = {
  UPDATE_VMO_BOT_DATA: "UPDATE_VMO_BOT_DATA",
  ADD_MESSAGE_TO_CHAT: "ADD_MESSAGE_TO_CHAT",
  UPDATE_MESSAGE_DATA: "UPDATE_MESSAGE_DATA",
  REMOVE_SUGGESTION: "REMOVE_SUGGESTION",
  UPLOAD_VMO_FILES: "UPLOAD_VMO_FILES",
  UPDATE_UPLOAD_STATUS: "UPDATE_UPLOAD_STATUS",
  UPDATE_PROCESSING_STAGE: "UPDATE_PROCESSING_STAGE",
  UPDATE_PROCESSED_FILES: "UPDATE_PROCESSED_FILES",
  SET_SUGGESTIONS: "SET_SUGGESTIONS",
  SET_MESSAGE_LOADER: "SET_MESSAGE_LOADER",
  RESET_VMO_BOT_CHAT: "RESET_VMO_BOT_CHAT",
  DELETE_FILES_FROM_GCS: "DELETE_FILES_FROM_GCS",
  SET_SELECTED_MODEL: "SET_SELECTED_MODEL",
  SET_MODAL_OPEN: "SET_MODAL_OPEN",
};

const addClauseCheckDocument = (doc: any) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: CLAUSE_CHECK_ACTIONS.ADD_DOCUMENT_FOR_CLAUSE_CHECK,
        payload: doc,
      });
    } catch (error) {}
  };
};

export const setModalOpen = (open: boolean) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: VMO_BOT_ACTIONS.SET_MODAL_OPEN,
        payload: open,
      });
    } catch (error) {
      console.error("Error setting modal open:", error);
    }
  };
};

const updateDataForClauseCheckDocumentsAfterUpload = (
  file_id: string,
  doc: any
) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: CLAUSE_CHECK_ACTIONS.UPDATE_DETAILS_OF_UPLOADING_DOCUMENT_FOR_CLAUSE_CHECK_AFTER_SUCCESSFUL_UPLOAD,
        payload: {
          file_id: file_id,
          doc: doc,
        },
      });
    } catch (error) {}
  };
};

const updateDataForClauseCheckDocument = (file_id: any, data: any) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: CLAUSE_CHECK_ACTIONS.UPDATE_DATA_FOR_CLAUSE_CHECK_DOCUMENT,
        payload: {
          file_id: file_id,
          data: data,
        },
      });
    } catch (err) {}
  };
};

export const uploadFileForClauseCheckThunk = ({
  docs,
  isLocal,
  isUploadFromLocalOrDrive = true,
}: {
  docs: any[];
  isLocal: boolean;
  isUploadFromLocalOrDrive?: boolean;
}) => {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch({
        type: CLAUSE_CHECK_ACTIONS.SET_CLAUSE_CHECK_DATA,
        payload: {
          loading: true,
          uploadProcessCompleted: false,
        },
      });
      // 1st pass: Prepare documents for initial display and add to state
      const fileObjectsForInitialDisplay = docs.map((doc: any) => {
        const baseDocData = isLocal
          ? { file_name: doc.name, original_file_name: doc.name }
          : doc;
        const contractDoc = new ContractDocument(baseDocData);
        return {
          ...contractDoc,
          loading: true,
          status: clauseCheckDocStatus.META_DATA_TO_BE_EXTRACTED,
          client_temp_id: isLocal ? doc.name : doc.id,
        };
      });

      fileObjectsForInitialDisplay?.forEach(async (doc: any) => {
        await dispatch(addClauseCheckDocument(doc));
      });

      let res: any;
      const auth = Auth.getInstance();
      if (isUploadFromLocalOrDrive === false) {
        // Document Store upload
        const gcsPaths: string[] = (docs ?? [])
          .map((doc) => doc.filepath_gcs_uri || doc.filepath || doc.name)
          .filter((x): x is string => Boolean(x));
        res = await uploadFileToGCS(
          "KEY_CONTRACT_CLAUSES",
          auth.getGoogleAccessToken() || "",
          gcsPaths as any,
          {}
        );
      } else if (isLocal) {
        const formData = new FormData();
        if (!docs || docs.length === 0) {
          throw new Error("No files selected for Clause Check local upload.");
        }
        let filesAddedCount = 0;
        docs.forEach((doc: { file: File; name: string }) => {
          if (doc.file instanceof File) {
            formData.append("file_objects", doc.file, doc.name);
            filesAddedCount++;
          } else {
            console.warn(
              `[Clause Check Thunk] Skipping invalid file object for local upload:`,
              doc
            );
          }
        });
        if (filesAddedCount === 0) {
          throw new Error(
            "No valid files were found to upload for Clause Check."
          );
        }
        res = await uploadFilesFromLocalForClauseCheck(formData);
      } else {
        const fileObjectsForRequestBody = docs.map(
          (doc: any) => new ClauseCheckDocumentRequestModel(doc)
        );
        res = await uploadFilesFromDriveForClauseCheck({
          file_objects: fileObjectsForRequestBody,
        });
      }
      // On successfull upload
      if (Array.isArray(res?.data)) {
        // 2nd pass to sanitize response
        // Resetting the table states incase a new batch of files are uploaded
        dispatch(resetTableState(TableTypes.BULK_CLAUSE));
        dispatch(resetTableState(TableTypes.BULK_SUMMARY));

        // 2nd pass: Update client-side docs with server data
        for (const serverDoc of res.data) {
          const matcherValue = isLocal
            ? serverDoc.original_file_name || serverDoc.file_name // Server should return this for local uploads
            : serverDoc?.drive_details?.file_id; // This was stored as client_temp_id for Drive

          await dispatch({
            type: CLAUSE_CHECK_ACTIONS.UPDATE_DETAILS_OF_UPLOADING_DOCUMENT_FOR_CLAUSE_CHECK_AFTER_SUCCESSFUL_UPLOAD,
            payload: {
              matcherKey: "client_temp_id",
              matcherValue: matcherValue,
              doc: serverDoc,
            },
          });
        }

        // 3rd pass: Call metadata API and initiate clause extraction for each uploaded document.
        for (const serverDoc of res.data) {
          const serverGeneratedDocId = serverDoc?.id;
          const response = await extractMetaDataOfDocumentForClauseCheck({
            doc_id: serverGeneratedDocId,
          });

          // Updating metadata for a document, disabling the loader for document, updating the metadata status
          await dispatch(
            updateDataForClauseCheckDocument(serverGeneratedDocId, {
              metadata: new MetaData(response?.metadata),
              loading: false,
              status: clauseCheckDocStatus.META_DATA_EXTRACTED,
            })
          );

          // initiate clause check extraction for all documents
          initiateClauseDataExtraction({
            doc_id: serverGeneratedDocId,
          });

          dispatch(
            updateDataForClauseCheckDocument(serverGeneratedDocId, {
              status: clauseCheckDocStatus.CLAUSE_CHECK_IN_PROGRESS,
            })
          );
        }
      } // End of if (Array.isArray(res?.data))

      // On successfull completion
      dispatch({
        type: CLAUSE_CHECK_ACTIONS.SET_CLAUSE_CHECK_DATA,
        payload: {
          loading: false,
          uploadProcessCompleted: true,
        },
      });

      getToast(
        "Success",
        `${docs?.length > 1 ? "Files" : "File"} uploaded successfully`
      );
    } catch (error: any) {
      getToast(
        "Error",
        error?.message || "Something went wrong with the Clause Check upload."
      );
      // Clear out any pending documents from state on error
      dispatch({
        type: CLAUSE_CHECK_ACTIONS.REMOVE_DOCUMENT_FROM_CLAUSE_CHECK,
      });
      dispatch({
        type: CLAUSE_CHECK_ACTIONS.SET_CLAUSE_CHECK_DATA,
        payload: { uploadProcessCompleted: true }, // Mark process as completed even if it failed
      });
    }
  };
};

export const uploadFileForContractReviewThunk = ({
  file,
  fileDetails,
  isLocal,
  isUploadFromLocalOrDrive = true,
}: {
  file: File | string;
  fileDetails: {
    file_name: string;
    source_file_name?: string;
    content_type?: string;
    id?: string;
  };
  isLocal: boolean;
  isUploadFromLocalOrDrive?: boolean;
}) => {
  return async (dispatch: any) => {
    const file_name = getFileNameWithoutExtension(fileDetails.file_name);
    const fileData = new ContractDocument({
      file_name: file_name,
      status: "review_pending",
      id: String(new Date().getTime()),
    });
    try {
      dispatch({
        type: CONTRACT_REVIEW_ACTIONS.ADD_DOCUMENT,
        payload: fileData,
      });
      dispatch({
        type: CONTRACT_REVIEW_ACTIONS.UPDATE_FILE_UPLOAD_STATUS,
        payload: {
          isUploading: true,
          error: {},
          uploaded: false,
        },
      });

      let res;
      if (isUploadFromLocalOrDrive) {
        res = isLocal
          ? await (async () => {
              if (!(file instanceof File)) {
                throw new Error(
                  "File object expected for local contract review upload."
                );
              }
              return await uploadFromLocalToDrive({ file });
            })()
          : await fileUploadFromDrive({
              file_name: fileDetails.file_name,
              file_id: fileDetails?.id || "",
            });
      } else {
        if (typeof file !== "string") {
          throw new Error(
            "File GCS URI string expected for contract review Document Store upload."
          );
        }
        const auth = Auth.getInstance();
        res = await uploadFileToGCS(
          "CONTRACT_REDLINING",
          auth.getGoogleAccessToken() || "",
          [file] as any,
          {}
        );
      }

      const docId = res?.data?.id;
      let newFileData = {
        ...fileData,
        id: docId,
      };

      await convertDocToPdf({
        file_name: fileDetails.file_name,
      });

      const data = await getDocMetaData({ doc_id: docId });
      newFileData = {
        ...newFileData,
        metadata: new MetaData(data?.metadata),
      };

      dispatch({
        type: CONTRACT_REVIEW_ACTIONS.UPDATE_DETAILS_OF_UPLOADING_DOCUMENT,
        payload: { newFileData, docId },
      });

      dispatch({
        type: CONTRACT_REVIEW_ACTIONS.UPDATE_PENDING_DOC_COUNT,
        payload: {},
      });

      dispatch({
        type: CONTRACT_REVIEW_ACTIONS.UPDATE_FILE_UPLOAD_STATUS,
        payload: {
          isUploading: false,
          error: {},
          uploaded: true,
        },
      });

      getToast("Success", "File uploaded successfully.");
    } catch (error) {
      dispatch({
        type: CONTRACT_REVIEW_ACTIONS.UPDATE_FILE_UPLOAD_STATUS,
        payload: {
          isUploading: false,
          error: error,
          uploaded: false,
        },
      });
      dispatch({
        type: CONTRACT_REVIEW_ACTIONS.REMOVE_DOCUMENT,
        payload: {},
      });
      getToast("Error", "File could not be uploaded.");
    }
  };
};

export const uploadFileForContractDraftingThunk = ({
  file,
  fileDetails,
  isLocal,
  selectedTemplate,
  callFromChabot = false,
  isUploadFromLocalOrDrive = true,
}: {
  file: File;
  fileDetails: {
    file_name: string;
    source_file_name?: string;
    content_type?: string;
    id?: string;
  };
  isLocal: boolean;
  selectedTemplate: { id: string };
  callFromChabot?: boolean;
  isUploadFromLocalOrDrive?: boolean;
}) => {
  return async (dispatch: any) => {
    const file_name = getFileNameWithoutExtension(fileDetails.file_name);

    try {
      dispatch({
        type: CONTRACT_DRAFTING_ACTIONS.UPDATE_CONTRACT_DRAFTING_DATA,
        payload: {
          fileUpload: {
            isUploading: true,
            error: {},
            uploaded: false,
          },
        },
      });

      dispatch({
        type: CONTRACT_DRAFTING_ACTIONS.UPDATE_CONTRACT_DRAFTING_DATA,
        payload: { file_name: file_name },
      });
      let res;
      if (isUploadFromLocalOrDrive) {
        if (isLocal) {
          res = await uploadDraftingDocFromLocal({
            intake_form: file,

            id_template_mapping:
              selectedTemplate?.id === ""
                ? "123e4567-e89b-12d3-a456-426614174000"
                : selectedTemplate?.id,
          });
        } else {
          res = await uploadDraftingDocFromDrive({
            file_name: fileDetails.file_name,
            file_id: fileDetails?.id || "",
            id_template_mapping: selectedTemplate?.id,
          });
        }
      } else {
        res = await uploadFileToGCS(
          "CONTRACT_DRAFTING",
          Auth.getInstance().getGoogleAccessToken() || "",
          [file],
          { id: selectedTemplate?.id }
        );
      }

      // New response structure for the drafting feature
      if (res?.status === true) {
        dispatch({
          type: CONTRACT_DRAFTING_ACTIONS.UPDATE_CONTRACT_DRAFTING_DATA,
          payload: {
            intakeFormValidated: true,
            docId: res?.id_drafted_contracts,
          },
        });

        dispatch({
          type: CONTRACT_DRAFTING_ACTIONS.UPDATE_CONTRACT_DRAFTING_DATA,
          payload: {
            fileUpload: {
              isUploading: false,
              error: {},
              uploaded: true,
            },
          },
        });
      } else {
        throw new Error(res?.status_message || "File validation failed");
      }
    } catch (error) {
      dispatch({
        type: CONTRACT_DRAFTING_ACTIONS.UPDATE_CONTRACT_DRAFTING_DATA,
        payload: {
          intakeFormValidated: false,
          fileUpload: {
            isUploading: false,
            error: error,
            uploaded: false,
          },
        },
      });
      if (!callFromChabot) {
        getToast(
          "Error",
          "Missing information in the intake form. Check the intake form."
        );
      }
    }
  };
};

export const updateRfxEvaluationData = (payload: any) => {
  return async (dispatch: any) => {
    dispatch({
      type: RFX_EVALUATION_ACTIONS.UPDATE_RFX_EVALUATION_DATA,
      payload: payload,
    });
  };
};

export const uploadFilesForRfxEvaluationThunk = (thunkBody: {
  docsFromDrive?: {
    filepath_gcs_uri?: string;
    filepath?: string;
    name?: string;
    id?: string;
  }[];
  filesFromLocal: {
    file: File;
    name: string;
  }[];
  isLocal: boolean;
  isUploadFromLocalOrDrive?: boolean;
}) => {
  return async (dispatch: any) => {
    const {
      docsFromDrive,
      filesFromLocal,
      isLocal,
      isUploadFromLocalOrDrive = true,
    } = thunkBody;
    try {
      const docs = isLocal ? filesFromLocal : docsFromDrive;
      const preUploadDocs = docs?.map(
        (doc: any, idx) => new FileForRfxEvaluation({ ...doc, id: idx })
      );
      dispatch(
        updateRfxEvaluationData({
          docsUploading: true,
          docs: {
            rfx_files: preUploadDocs,
          },
          error: {},
        })
      );

      let res: IUploadedDocsForRFxEvaluation = {
        rfx_files: [],
      };
      const auth = Auth.getInstance();

      if (isUploadFromLocalOrDrive === false) {
        // Document Store upload
        const gcsPaths: string[] = (docsFromDrive ?? [])
          .map((doc) => doc.filepath_gcs_uri || doc.filepath || doc.name)
          .filter((x): x is string => Boolean(x));
        res = await uploadFileToGCS(
          "RFX_EVALUATION",
          auth.getGoogleAccessToken() || "",
          gcsPaths as any,
          {}
        );
      } else if (isLocal) {
        // Process files from Local
        const formData = new FormData();
        filesFromLocal?.map((fileObj) =>
          formData.append("files", fileObj?.file)
        );
        res = await uploadFilesForRFxEvaluation(formData);
      } else {
        // Process files from Drive
        const fileObjectsForRequestBody = docs?.map(
          (doc: any) => new ClauseCheckDocumentRequestModel(doc)
        );

        res = await uploadFilesFromDriveForRFxEvaluation({
          file_objects: fileObjectsForRequestBody || [],
        });
      }

      dispatch(
        updateRfxEvaluationData({
          docsUploading: false,
          docsUploaded: true,
          docs: {
            ...res,
            rfx_files: res?.rfx_files?.map(
              (doc: any) => new FileForRfxEvaluation(doc)
            ),
          },
        })
      );

      getToast(
        "Success",
        `${preUploadDocs?.length} new RFx have been uploaded.`
      );
    } catch (error: any) {
      const errorMessage = error?.response?.data?.status_message;
      getToast("Error", errorMessage || "RFx couldn't be uploaded.");
      dispatch(
        updateRfxEvaluationData({
          docsUploading: false,
          docsUploaded: false,
          error: error,
          docs: [],
        })
      );
    }
  };
};

export const removeDraftingFile = () => {
  return async (dispatch: any) => {
    dispatch({
      type: CONTRACT_DRAFTING_ACTIONS.UPDATE_CONTRACT_DRAFTING_DATA,
      payload: {
        fileUpload: {
          isUploading: false,
          error: {},
          uploaded: false,
        },
      },
    });
  };
};

export const getContractDraftingTemplates = () => {
  return async (dispatch: any) => {
    try {
      const response = await getDraftingTemplatesList();
      dispatch({
        type: CONTRACT_DRAFTING_ACTIONS.UPDATE_CONTRACT_DRAFTING_DATA,
        payload: {
          templateOptions: {
            data: response?.data || [],
          },
        },
      });
    } catch (error) {
      dispatch({
        type: CONTRACT_DRAFTING_ACTIONS.UPDATE_CONTRACT_DRAFTING_DATA,
        payload: {
          templateOptions: {
            data: [],
            error: error,
          },
        },
      });
    }
  };
};

export const updateContractDraftingData = (payload: any) => {
  return async (dispatch: any) => {
    dispatch({
      type: CONTRACT_DRAFTING_ACTIONS.UPDATE_CONTRACT_DRAFTING_DATA,
      payload: payload,
    });
  };
};

export const uploadFileForRfxGeneratorThunk = ({
  file,
  fileDetails,
  isLocal,
  rfxGeneratorSelectedTemplate,
  isUploadFromLocalOrDrive = true,
}: {
  file: File;
  fileDetails: {
    file_name: string;
    source_file_name?: string;
    content_type?: string;
    id?: string;
  };
  isLocal: boolean;
  rfxGeneratorSelectedTemplate: { id: string };
  isUploadFromLocalOrDrive?: boolean;
}) => {
  const auth = Auth.getInstance();

  return async (dispatch: any) => {
    const file_name = getFileNameWithoutExtension(fileDetails.file_name);

    try {
      dispatch({
        type: RFX_GENERATOR_ACTIONS.UPDATE_RFX_GENERATOR_DATA,
        payload: {
          fileUpload: {
            isUploading: true,
            error: {},
            uploaded: false,
          },
        },
      });

      dispatch({
        type: RFX_GENERATOR_ACTIONS.UPDATE_RFX_GENERATOR_DATA,
        payload: { file_name: file_name },
      });

      let res;
      if (isUploadFromLocalOrDrive) {
        if (isLocal) {
          res = await uploadRfxGeneratorDocFromLocal({
            intake_form: file,
            rfx_template_id: rfxGeneratorSelectedTemplate?.id,
          });
        } else {
          res = await uploadRfxGeneratorDocFromDrive({
            file_name: fileDetails.file_name,
            file_id: fileDetails?.id || "",
            id_template_mapping: rfxGeneratorSelectedTemplate?.id,
          });
        }
      } else {
        res = await uploadFileToGCS(
          "RFX_GENERATION",
          auth.getGoogleAccessToken() || "",
          [file],
          { id: rfxGeneratorSelectedTemplate?.id }
        );
      }

      if (res?.status === true) {
        dispatch({
          type: RFX_GENERATOR_ACTIONS.UPDATE_RFX_GENERATOR_DATA,
          payload: { intakeFormValidated: true, docId: res?.id_drafted_Rfx },
        });

        dispatch({
          type: RFX_GENERATOR_ACTIONS.UPDATE_RFX_GENERATOR_DATA,
          payload: {
            fileUpload: {
              isUploading: false,
              error: {},
              uploaded: true,
            },
          },
        });

        // getToast(
        //   "Success",
        //   res.status_message || "File uploaded successfully."
        // );
      } else {
        throw new Error(res?.status_message || "File validation failed");
      }
    } catch (error: any) {
      dispatch({
        type: RFX_GENERATOR_ACTIONS.UPDATE_RFX_GENERATOR_DATA,
        payload: {
          intakeFormValidated: false,
          fileUpload: {
            isUploading: false,
            error: error,
            uploaded: false,
          },
        },
      });
      if (error.response.data.status_message) {
        getToast("Error", error.response.data.status_message);
      } else {
        getToast(
          "Error",
          "Missing information in the intake form. Check the intake form."
        );
      }
    }
  };
};

export const getRfxGeneratorTemplates = () => {
  return async (dispatch: any) => {
    try {
      const response = await getRfxGeneratorTemplatesList();
      dispatch({
        type: RFX_GENERATOR_ACTIONS.UPDATE_RFX_GENERATOR_DATA,
        payload: {
          templateOptions: {
            data: response?.data || [],
          },
        },
      });
    } catch (error) {
      dispatch({
        type: RFX_GENERATOR_ACTIONS.UPDATE_RFX_GENERATOR_DATA,
        payload: {
          templateOptions: {
            data: [],
            error: error,
          },
        },
      });
    }
  };
};

export const removeRfxGeneratorFile = () => {
  return async (dispatch: any) => {
    dispatch({
      type: RFX_GENERATOR_ACTIONS.UPDATE_RFX_GENERATOR_DATA,
      payload: {
        fileUpload: {
          isUploading: false,
          error: {},
          uploaded: false,
        },
      },
    });
  };
};

export const updateRfxGeneratorData = (payload: any) => {
  return async (dispatch: any) => {
    dispatch({
      type: RFX_GENERATOR_ACTIONS.UPDATE_RFX_GENERATOR_DATA,
      payload: payload,
    });
  };
};

export const resetRfxGeneratorTemplate = () => {
  return async (dispatch: any) => {
    dispatch({
      type: RFX_GENERATOR_ACTIONS.UPDATE_RFX_GENERATOR_DATA,
      payload: {
        rfxGeneratorSelectedTemplates: null,
      },
    });
  };
};

export const uploadMutliDocFromBotThunk = ({
  docs,
  isLocal,
  isUploadFromLocalOrDrive = true,
}: {
  docs: any[];
  isLocal: boolean;
  isUploadFromLocalOrDrive?: boolean;
}) => {
  return async (dispatch: any, getState: any) => {
    try {
      dispatch({
        type: VMO_BOT_ACTIONS.UPDATE_VMO_BOT_DATA,
        payload: {
          isUploading: true,
          uploadProcessCompleted: false,
          error: null,
        },
      });
      let res: any;
      let filesForInitialDisplay: any[];
      if (isUploadFromLocalOrDrive === false) {
        const auth = Auth.getInstance();
        const gcsPaths: string[] = (docs ?? [])
          .map((doc) => doc.filepath_gcs_uri || doc.filepath || doc.name)
          .filter((x): x is string => Boolean(x));

        filesForInitialDisplay = docs.map((doc: any, index: number) => ({
          id: doc.id || `docstore-${Date.now()}-${index}`,
          name: addDocExtentionIfMissing(doc.name),
          size: doc.size || 0,
          mimeType: doc.mimeType || "",
          iconUrl: determineIconUrl(doc.mimeType || doc.name || ""),
        }));

        dispatch({
          type: VMO_BOT_ACTIONS.UPLOAD_VMO_FILES,
          payload: filesForInitialDisplay,
        });
        dispatch({
          type: VMO_BOT_ACTIONS.UPDATE_PROCESSING_STAGE,
          payload: "ShowUploadedFiles",
        });

        res = await uploadFileToGCS(
          "TALK_TO_CONTRACT",
          auth.getGoogleAccessToken() || "",
          gcsPaths as any,
          {}
        );
      } else if (isLocal) {
        filesForInitialDisplay = docs.map(
          (doc: { name: string; file: File }, index: number) => ({
            id: `local-${Date.now()}-${index}`,
            name: addDocExtentionIfMissing(doc?.name),
            size: doc.file.size,
            mimeType: doc.file.type,
            iconUrl: determineIconUrl(doc.file.type),
          })
        );

        dispatch({
          type: VMO_BOT_ACTIONS.UPLOAD_VMO_FILES,
          payload: filesForInitialDisplay,
        });
        dispatch({
          type: VMO_BOT_ACTIONS.UPDATE_PROCESSING_STAGE,
          payload: "ShowUploadedFiles",
        });

        const formData = new FormData();
        if (!docs || docs.length === 0) {
          throw new Error("No files provided for local upload.");
        }
        docs.forEach((doc: { file: File; name: string }) => {
          const fileNameWithExtension = addDocExtentionIfMissing(doc.name);
          formData.append("files", doc.file, fileNameWithExtension);
        });
        formData.append("feature", "talk_to_contract");
        res = await uploadMultipleFilesFromLocalForTalkToContract(formData);
      } else {
        filesForInitialDisplay = docs;

        dispatch({
          type: VMO_BOT_ACTIONS.UPLOAD_VMO_FILES,
          payload: filesForInitialDisplay,
        });
        dispatch({
          type: VMO_BOT_ACTIONS.UPDATE_PROCESSING_STAGE,
          payload: "ShowUploadedFiles",
        });

        const docsToBeUploadedForDrive: any = [];
        docs.forEach((doc: any) => {
          docsToBeUploadedForDrive.push({
            file_name: addDocExtentionIfMissing(doc?.name),
            file_id: doc?.id,
          });
        });
        res = await uploadMultipleFilesToDrive(docsToBeUploadedForDrive);
      }
      if (
        res?.data &&
        (Array.isArray(res.data)
          ? res.data.length > 0
          : Object.keys(res.data).length > 0)
      ) {
        dispatch({
          type: VMO_BOT_ACTIONS.UPDATE_UPLOAD_STATUS,
          payload: false,
        });

        let processedFilesPayload = res?.data;
        if (Array.isArray(res?.data)) {
          // If res.data is array of strings, use as-is. If array of objects, extract name.
          processedFilesPayload = res.data.map(
            (fileFromServer: any) =>
              fileFromServer.name ||
              fileFromServer.file_name ||
              fileFromServer.original_filename ||
              fileFromServer
          );
        } else {
          processedFilesPayload = processedFilesPayload
            ? [processedFilesPayload]
            : [];
        }

        // if (Array.isArray(res?.data)) {
        //   processedFilesPayload = res.data.map((fileFromServer: any) => ({
        //     // id: fileFromServer.id || fileFromServer.file_id || fileFromServer.doc_id || `processed-${Date.now()}-${Math.random()}`,
        //     // name: fileFromServer.name || fileFromServer.file_name || fileFromServer.original_filename,
        //     // ...fileFromServer,
        //     fileFromServer,
        //   }));
        // } else {
        //   processedFilesPayload = Array.isArray(processedFilesPayload) ? processedFilesPayload : (processedFilesPayload ? [processedFilesPayload] : []);
        // }

        dispatch({
          type: VMO_BOT_ACTIONS.UPDATE_PROCESSED_FILES,
          payload: processedFilesPayload,
        });
        getToast(
          "Success",
          `${docs.length > 1 ? "Files" : "File"} uploaded successfully.`
        );
        dispatch({
          type: VMO_BOT_ACTIONS.UPDATE_VMO_BOT_DATA,
          payload: {
            isUploading: false,
            uploadProcessCompleted: true,
            error: null,
          },
        });
      }
    } catch (err) {
      dispatch({
        type: VMO_BOT_ACTIONS.UPDATE_VMO_BOT_DATA,
        payload: {
          isUploading: false,
          uploadProcessCompleted: true,
          error: err,
        },
      });
      getToast("Error", "Files could not be uploaded.");
      dispatch({
        type: VMO_BOT_ACTIONS.UPDATE_PROCESSING_STAGE,
        payload: "SelectFiles",
      });
    }
  };
};

export const getContractsReviewThunk = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: CONTRACT_REVIEW_ACTIONS.SET_CONTRACT_REVIEW_DATA,
        payload: {
          loading: true,
          error: {},
        },
      });

      const res = await getContractsReview();
      const data = new ContractReviewModel(res);

      dispatch({
        type: CONTRACT_REVIEW_ACTIONS.SET_CONTRACT_REVIEW_DATA,
        payload: {
          ...data,
          loading: false,
          error: {},
        },
      });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.status_message;
      getToast("Error", errorMessage);
      dispatch({
        type: CONTRACT_REVIEW_ACTIONS.SET_CONTRACT_REVIEW_DATA,
        payload: {
          loading: false,
          error: error,
          list: [],
        },
      });
    }
  };
};

export const getFailedClauseThunk = () => {
  return async (dispatch: any) => {
    try {
      const failedDocRes = await getClauseCheckDocumentsDataForDashboard({
        clause_status: [clauseCheckDocStatus.FAILED_WHILE_REVIEWING],
        page: 1,
        page_size: 100,
      });

      const sanitizedFaileDocRes = new BulkClauseTableData(failedDocRes);
      dispatch({
        type: CLAUSE_CHECK_ACTIONS.SET_FAILED_DOC_DATA,
        payload: sanitizedFaileDocRes,
      });
    } catch (err) {}
  };
};

export const getLatestClauseCheckDataForDashboard = () => {
  return async (dispatch: any) => {
    try {
      const dashboardData = await getClauseCheckDocumentsDataForDashboard();

      const documents = dashboardData?.results;

      const sanitizedDocsData = documents?.map(
        (doc: any) => new ContractDocument(doc)
      );

      const updatedClauseCheckData = {
        pending_documents: {
          list: sanitizedDocsData,
        },
      };

      dispatch({
        type: CLAUSE_CHECK_ACTIONS.SET_CLAUSE_CHECK_DATA,
        payload: {
          ...updatedClauseCheckData,
          loading: false,
          error: {},
        },
      });
    } catch (error) {
      dispatch({
        type: CLAUSE_CHECK_ACTIONS.SET_CLAUSE_CHECK_DATA,
        payload: {
          loading: false,
          error: error,
        },
      });
    }
  };
};

export const getClauseCheckThunk = ({ polling }: { polling: boolean }) => {
  return async (dispatch: any) => {
    try {
      if (!polling) {
        dispatch({
          type: CLAUSE_CHECK_ACTIONS.SET_CLAUSE_CHECK_DATA,
          payload: {
            loading: true,
            error: {},
          },
        });
      }

      const res = await getClauseCheckDataForDashboard();
      const data = new ClauseCheckModel(res);

      const failedDocRes = await getClauseCheckDocumentsDataForDashboard({
        clause_status: [clauseCheckDocStatus.FAILED_WHILE_REVIEWING],
        page: 1,
        page_size: 100,
      });

      const sanitizedFaileDocRes = new BulkClauseTableData(failedDocRes);
      const dashboardData = await getClauseCheckDocumentsDataForDashboard();

      const documents = dashboardData?.results;

      const sanitizedDocsData = documents?.map(
        (doc: any) => new ContractDocument(doc)
      );

      const updatedClauseCheckData = {
        ...data,
        pending_documents: {
          list: sanitizedDocsData,
        },
        failed_documents: sanitizedFaileDocRes,
      };

      dispatch({
        type: CLAUSE_CHECK_ACTIONS.SET_CLAUSE_CHECK_DATA,
        payload: {
          ...updatedClauseCheckData,
          loading: false,
          error: {},
        },
      });
    } catch (error) {
      dispatch({
        type: CLAUSE_CHECK_ACTIONS.SET_CLAUSE_CHECK_DATA,
        payload: {
          loading: false,
          error: error,
        },
      });
    }
  };
};

export const openCloseVmoBotThunk = (open: boolean) => {
  return async (dispatch: any) => {
    dispatch({
      type: VMO_BOT_ACTIONS.UPDATE_VMO_BOT_DATA,
      payload: {
        open: open,
      },
    });
  };
};

export const updateVmoBotModel = (data: any) => {
  return async (dispatch: any) => {
    dispatch({
      type: VMO_BOT_ACTIONS.SET_SELECTED_MODEL,
      payload: data,
    });
  };
};

export const sendMessageToVmoBotThunk = (message: string) => {
  return async (dispatch: any, getState: any) => {
    const date = new Date().getTime();
    const userMessageId = date + 1;
    const botMessageId = date + 2;

    try {
      await dispatch({
        type: VMO_BOT_ACTIONS.ADD_MESSAGE_TO_CHAT,
        payload: {
          sender: "user",
          text: message,
          id: userMessageId,
        },
      });

      await dispatch({
        type: VMO_BOT_ACTIONS.SET_MESSAGE_LOADER,
        payload: true,
      });

      await dispatch({
        type: VMO_BOT_ACTIONS.ADD_MESSAGE_TO_CHAT,
        payload: {
          sender: "bot",
          text: "",
          id: botMessageId,
          loading: true,
        },
      });

      const processedFiles =
        getState()?.rootReducer?.vscDashboardReducer?.vmoBot?.fileUpload
          ?.processedFiles || [];

      const selectedModel =
        getState()?.rootReducer?.vscDashboardReducer?.vmoBot?.selectedModel;
      const botResponse = await getVmoBotResponse({
        files: processedFiles,
        question: message,
        model: selectedModel?.name,
      });

      const { answer = [], suggested_questions = [] } = botResponse;

      await dispatch({
        type: VMO_BOT_ACTIONS.UPDATE_MESSAGE_DATA,
        payload: {
          id: botMessageId,
          text: answer,
          loading: false,
        },
      });

      await dispatch({
        type: VMO_BOT_ACTIONS.SET_MESSAGE_LOADER,
        payload: false,
      });

      const suggestions = suggested_questions?.map(
        (suggestion: any) => new Suggestion(suggestion)
      );

      await dispatch({
        type: VMO_BOT_ACTIONS.SET_SUGGESTIONS,
        payload: suggestions || defaultSuggestions,
      });
    } catch (error) {
      getToast("Error", "Something went wrong.");

      await dispatch({
        type: VMO_BOT_ACTIONS.SET_MESSAGE_LOADER,
        payload: false,
      });

      await dispatch({
        type: VMO_BOT_ACTIONS.UPDATE_MESSAGE_DATA,
        payload: {
          id: botMessageId,
          text: "The requested information couldn't be retrieved. Please try again later.",
          loading: false,
          errored: true,
        },
      });
    }
  };
};

export const sendSuggestionToVmoBotThunk = (suggestion: { text: string }) => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: VMO_BOT_ACTIONS.REMOVE_SUGGESTION,
        payload: {
          text: suggestion?.text,
        },
      });

      await dispatch(sendMessageToVmoBotThunk(suggestion?.text));
    } catch (error) {}
  };
};

export const resetVmoBotChatThunk = () => {
  return async (dispatch: any) => {
    try {
      dispatch({
        type: VMO_BOT_ACTIONS.DELETE_FILES_FROM_GCS,
      });
      dispatch({
        type: VMO_BOT_ACTIONS.RESET_VMO_BOT_CHAT,
      });
    } catch (error) {}
  };
};

export const storeDocId = (docId: string) => {
  return async (dispatch: any) => {
    dispatch({
      type: CONTRACT_REVIEW_ACTIONS.ADD_DOCUMENT_ID,
      payload: {
        docId: docId,
      },
    });
  };
};

export const emptyList = () => {
  return async (dispatch: any) => {
    dispatch({
      type: CONTRACT_REVIEW_ACTIONS.EMPTY_LIST,
      payload: {},
    });
  };
};

export const handleUseEffectCount = (val: boolean) => {
  return async (dispatch: any) => {
    dispatch({
      type: CONTRACT_DRAFTING_ACTIONS.HANDLE_USE_EFFECT_COUNT,
      payload: {
        call: val,
      },
    });
  };
};

export const saveLoaderState = ({ generating }: { generating: boolean }) => {
  return async (dispatch: any) => {
    dispatch({
      type: CONTRACT_DRAFTING_ACTIONS.SAVE_LOADER_STATE,
      payload: {
        generating,
      },
    });
  };
};

export const storeFileId = ({
  fileId,
  fileNameResponse,
}: {
  fileId: string;
  fileNameResponse: string;
}) => {
  return async (dispatch: any) => {
    dispatch({
      type: CONTRACT_DRAFTING_ACTIONS.STORE_FILE_ID,
      payload: {
        fileId,
        fileNameResponse, // <-- Updated to include fileNameResponse
      },
    });
  };
};

export const storeChatHistory = (chatHistory: any[]) => {
  return async (dispatch: any) => {
    dispatch({
      type: CONTRACT_REVIEW_ACTIONS.STORE_CHAT,
      payload: {
        chatHistory,
      },
    });
  };
};
